// extracted by mini-css-extract-plugin
export var printerCard = "_9o-1";
export var printerCardConfigured = "_9o-2";
export var printerCardError = "_9o-3";
export var printerCardsContainer = "_9o-0";
export var printerIcon = "_9o-8";
export var printerIconConfigured = "_9o-5";
export var printerIconContainer = "_9o-4";
export var printerIconError = "_9o-6";
export var printerIconUnconfigured = "_9o-7";
export var workstationsTableCard = "_9o-9";